import './i18n';
import { useTranslation as useI18Next } from 'react-i18next';
import { useUser } from 'components/user/UserProvider';
import { createContext } from 'libs/react';
import { useContext } from 'libs/react';
import { useEffect } from 'libs/react';
import { useOnce } from 'libs/react';
import { React } from 'libs/react';
import { useAccount } from 'components/account/AccountProvider';
/**
 * @component TranslationProvider
 * @since 1.0.0
 */
export function TranslationProvider(props) {
    var _a, _b, _c, _d;
    const { i18n, ready } = useI18Next();
    const { user } = useUser();
    const account = useAccount();
    const code = (_a = user === null || user === void 0 ? void 0 : user.language) === null || _a === void 0 ? void 0 : _a.code;
    const language = (_c = (_b = user === null || user === void 0 ? void 0 : user.language) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : account.languages
        .filter((language) => language.primary == true)
        .map((language) => language.code)[0];
    useOnce(() => {
        if (code) {
            i18n.changeLanguage(code);
        }
    });
    useEffect(() => {
        if (code) {
            i18n.changeLanguage(code);
        }
    }, [code]);
    // Default labels
    const labels = {
        // Partners labels
        partner: {
            en: 'partner',
            fr: 'concessionnaire',
            es: 'distribuidor'
        },
        Partner: {
            en: 'Partner',
            fr: 'Partenaire',
            es: 'Asociado'
        },
        partners: {
            en: 'partners',
            fr: 'partenaires',
            es: 'asociados'
        },
        Partners: {
            en: 'Partners',
            fr: 'Partenaires',
            es: 'Asociados'
        },
        representative: {
            en: 'representative',
            fr: 'représentant',
            es: 'representante'
        },
        Representative: {
            en: 'Representative',
            fr: 'Représentant',
            es: 'Representante'
        },
        representatives: {
            en: 'representatives',
            fr: 'représentants',
            es: 'representantes'
        },
        Representatives: {
            en: 'Representatives',
            fr: 'Représentants',
            es: 'Representantes'
        },
        // Contacts labels
        contact: {
            en: 'contact',
            fr: 'contact',
            es: 'contacto'
        },
        Contact: {
            en: 'Contact',
            fr: 'Contact',
            es: 'Contacto'
        },
        contacts: {
            en: 'contacts',
            fr: 'contacts',
            es: 'contactos'
        },
        Contacts: {
            en: 'Contacts',
            fr: 'Contacts',
            es: 'Contactos'
        },
        // Clients labels
        client: {
            en: 'company',
            fr: 'Entreprise',
            es: 'empresa'
        },
        Client: {
            en: 'Company',
            fr: 'Entreprise',
            es: 'Empresa'
        },
        clients: {
            en: 'companies',
            fr: 'Entreprises',
            es: 'compañías'
        },
        Clients: {
            en: 'Companies',
            fr: 'Entreprises',
            es: 'Compañías'
        },
        // Sales labels
        deal: {
            en: 'quote',
            fr: 'soumission',
            es: 'trato'
        },
        Deal: {
            en: 'Quote',
            fr: 'Soumission',
            es: 'Trato'
        },
        deals: {
            en: 'quotes',
            fr: 'soumissions',
            es: 'tratos'
        },
        Deals: {
            en: 'Quotes',
            fr: 'Soumissions',
            es: 'Tratos'
        },
        CreateQuote: {
            en: 'Create Quote',
            fr: 'Créer une soumission',
            es: 'Crear una cotización'
        },
        // Items labels
        item: {
            en: 'product',
            fr: 'produit',
            es: 'artículo'
        },
        Item: {
            en: 'Product',
            fr: 'Item',
            es: 'Artículo'
        },
        saleItem: {
            en: 'product',
            fr: 'produit',
            es: 'producto'
        },
        SaleItem: {
            en: 'Product',
            fr: 'Produit',
            es: 'Producto'
        },
        SaleItems: {
            en: 'Products',
            fr: 'Produits',
            es: 'Productos'
        },
        saleItems: {
            en: 'products',
            fr: 'produits',
            es: 'productos'
        },
        // Order labels
        order: {
            en: 'order',
            fr: 'commande',
            es: 'orden'
        },
        Order: {
            en: 'Order',
            fr: 'Commande',
            es: 'Orden'
        },
        orders: {
            en: 'order',
            fr: 'commande',
            es: 'pedidos'
        },
        Orders: {
            en: 'Orders',
            fr: 'Commandes',
            es: 'Pedidos'
        },
        // Manufacturing labels
        manufacturing: {
            en: 'tasks and actions',
            fr: 'tâches et actions',
            es: 'tareas y acciones'
        },
        Manufacturing: {
            en: 'Tasks and actions',
            fr: 'Tâches et actions',
            es: 'Tareas y acciones'
        },
        manufacturingItems: {
            en: 'tasks and actions',
            fr: 'tâches et actions',
            es: 'tareas y acciones'
        },
        ManufacturingItems: {
            en: 'Tasks and actions',
            fr: 'Tâches et actions',
            es: 'Tareas y acciones'
        },
        manufacturingItem: {
            en: 'task or action',
            fr: 'tâche ou action',
            es: 'tarea o acción'
        },
        ManufacturingItem: {
            en: 'Task or action',
            fr: 'Tâche ou action',
            es: 'Tarea o acción'
        }
    };
    // Account labels
    // TODO : get account labels from backend
    if (((_d = user === null || user === void 0 ? void 0 : user.session.user.account) === null || _d === void 0 ? void 0 : _d.tag) == 'mrgcanada') {
        /*labels['contact'] = {
          en: 'customer',
          fr: 'client',
          es: 'cliente'
        };
        labels['Contact'] = {
          en: 'Customer',
          fr: 'Client',
          es: 'Cliente'
        };
        labels['contacts'] = {
          en: 'customers',
          fr: 'clients',
          es: 'clientes'
        };
        labels['Contacts'] = {
          en: 'Customers',
          fr: 'Clients',
          es: 'Clientes'
        };
        labels['client'] = {
          en: 'company',
          fr: 'entreprise',
          es: 'empresa'
        };
        labels['Client'] = {
          en: 'Company',
          fr: 'Entreprise',
          es: 'Empresa'
        };
        labels['clients'] = {
          en: 'companies',
          fr: 'entreprises',
          es: 'empresas'
        };
        labels['Clients'] = {
          en: 'Companies',
          fr: 'Entreprises',
          es: 'Empresas'
        };
        labels['partner'] = {
          en: 'dealer',
          fr: 'concessionnaire',
          es: 'concesionario'
        };
        labels['representative'] = {
          en: 'contact',
          fr: 'contact',
          es: 'contacto'
        };
        labels['Representative'] = {
          en: 'Contact',
          fr: 'Contact',
          es: 'Contacto'
        };
        labels['representatives'] = {
          en: 'contacts',
          fr: 'contacts',
          es: 'contactos'
        };
        labels['Representatives'] = {
          en: 'Contacts',
          fr: 'Contacts',
          es: 'Contactos'
        };
        */
    }
    const context = {
        language: language,
        // language: i18n.language.slice(0, 2),
        customLabels: labels
    };
    return (React.createElement(TranslationContext.Provider, { value: context }, ready ? props.children : null));
}
/**
 * @const TranslationContext
 * @since 1.0.0
 */
export const TranslationContext = createContext({
    language: '',
    customLabels: {}
});
/**
 * @function useTranslation
 * @since 1.0.0
 */
export function useTranslation() {
    return useContext(TranslationContext);
}
